import { Injectable } from '@angular/core';
import { UserService } from '../resources/user/user.service';
import { Observable } from 'rxjs/Observable';
import { CanActivate, Router } from '@angular/router';

@Injectable()
export class EditAccessGuard implements CanActivate {
  constructor(private user: UserService, private router: Router) {}
  canActivate(): Observable<boolean> {
    return this.user.editEnabled.do(v => {
      if (!v) {
        this.router.navigate(['/dashboard']);
      }
    });
  }
}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/guards/edit-access.guard.ts